import './App.css';
import { AuthContext, AuthProvider } from './provider/authProvider';
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Layout from './components/layout/layout';
import Login from './pages/login';
import Dashboard from './pages/dashboard';
import Cities from './pages/setting/cities';
import Streets from './pages/setting/streets';
import Branches from './pages/setting/branches';
import PostType from './pages/setting/postType';
import Roles from './pages/userManagment/roles';
import Users from './pages/userManagment/users';
import AddUser from './pages/userManagment/addUser';
import UpdateUser from './pages/userManagment/updateUser';
import Expense from './pages/expense/expense';
import ExpenseType from './pages/expense/expenseType';
import Drivers from './pages/driver/drivers';
import UpdateDriver from './pages/driver/updateDriver';
import AddDriver from './pages/driver/addDriver';
import Pages from './pages/page/pages';
import UpdatePage from './pages/page/updatePage';
import AddPage from './pages/page/addPage';
import CityPrices from './pages/setting/cityPrices';
import CompanyInfo from './pages/setting/companyInfo';
import Posts from './pages/post/posts';
import AddPost from './pages/post/addPost';
import BlockedNumbers from './pages/setting/blockedNumbers';
import UpdatePost from './pages/post/updatePost';
import Printers from './pages/setting/printers';
import AddDriverPayment from './pages/driver/addDriverPayment';
import DriverPayments from './pages/driver/driverPayments';
import AddPagePayment from './pages/page/addPagePayment';
import PagePayments from './pages/page/pagePayments';
import Notifications from './pages/notification/notifications';
import AddNotification from './pages/notification/addNotification';
import WalletTransfer from './pages/walletTransfer';
import ProfitReport from './pages/report/profitReport';
import MoneyMovementReport from './pages/report/moneyMovementReport';
import TotalActivityReport from './pages/report/totalActivityReport';
import RemainingsReport from './pages/report/remainingsReport';
import WhatsAppMsgs from './pages/whatsAppMsg/whatsAppMsgs';
import AddWhatsAppMsg from './pages/whatsAppMsg/addWhatsAppMsg';
import PostStatuses from './pages/setting/postStatuses';
import Profile from './pages/profile';
import Loans from './pages/loan/loans';
import AddLoan from './pages/loan/addLoan';
import UpdateLoan from './pages/loan/updateLoan';

function App() {
  function ProtectedRoute({ children, requiredPermissions }) {
    const { user, loading } = React.useContext(AuthContext);
    const location = useLocation();

    if (loading) {
      return <div>Loading...</div>;
    }

    if (!user) {
      return <Navigate to="/" state={{ from: location }} replace />;
    }

    if (requiredPermissions && !requiredPermissions.every(perm => user.permissions.some(p => p.value === perm))) {
      return <Navigate to="/" state={{ from: location }} replace />;
    }

    return children;
  }

  return (
    <AuthProvider>
      <Router future={{
        v7_relativeSplatPath: true,
        v7_startTransition: true
      }}>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
            {/* dashboard */}
            <Route path="/dashboard" element={<ProtectedRoute requiredPermissions={['dashboard']}><Dashboard /></ProtectedRoute>} />

            {/* post */}
            <Route path="/posts" element={<ProtectedRoute requiredPermissions={['post']}><Posts /></ProtectedRoute>} />
            <Route path="/add-post" element={<ProtectedRoute requiredPermissions={['post']}><AddPost /></ProtectedRoute>} />
            <Route path="/posts/:id" element={<ProtectedRoute requiredPermissions={['post']}><UpdatePost /></ProtectedRoute>} />

            {/* page */}
            <Route path="/pages" element={<ProtectedRoute requiredPermissions={['page']}><Pages /></ProtectedRoute>} />
            <Route path="/pages/:id" element={<ProtectedRoute requiredPermissions={['page']}><UpdatePage /></ProtectedRoute>} />
            <Route path="/add-page" element={<ProtectedRoute requiredPermissions={['page']}><AddPage /></ProtectedRoute>} />
            <Route path="/add-page-payment" element={<ProtectedRoute requiredPermissions={['pagePayment']}><AddPagePayment /></ProtectedRoute>} />
            <Route path="/page-payments" element={<ProtectedRoute requiredPermissions={['pagePayment']}><PagePayments /></ProtectedRoute>} />

            {/* driver */}
            <Route path="/drivers" element={<ProtectedRoute requiredPermissions={['driver']}><Drivers /></ProtectedRoute>} />
            <Route path="/drivers/:id" element={<ProtectedRoute requiredPermissions={['driver']}><UpdateDriver /></ProtectedRoute>} />
            <Route path="/add-driver" element={<ProtectedRoute requiredPermissions={['driver']}><AddDriver /></ProtectedRoute>} />
            <Route path="/add-driver-payment" element={<ProtectedRoute requiredPermissions={['driverPayment']}><AddDriverPayment /></ProtectedRoute>} />
            <Route path="/driver-payments" element={<ProtectedRoute requiredPermissions={['driverPayment']}><DriverPayments /></ProtectedRoute>} />

            {/* expense */}
            <Route path="/expenses" element={<ProtectedRoute requiredPermissions={['expense']}><Expense /></ProtectedRoute>} />
            <Route path="/expense-types" element={<ProtectedRoute requiredPermissions={['expense']}><ExpenseType /></ProtectedRoute>} />

            {/* wallet transfer*/}
            <Route path="/wallet-transfer" element={<ProtectedRoute requiredPermissions={['walletTransfer']}><WalletTransfer /></ProtectedRoute>} />

            {/* loan */}
            <Route path="/loans" element={<ProtectedRoute requiredPermissions={['loan']}><Loans /></ProtectedRoute>} />
            <Route path="/add-loan" element={<ProtectedRoute requiredPermissions={['loan']}><AddLoan /></ProtectedRoute>} />
            <Route path="/loans/:id" element={<ProtectedRoute requiredPermissions={['loan']}><UpdateLoan /></ProtectedRoute>} />

            {/* report */}
            <Route path="/profit-report" element={<ProtectedRoute requiredPermissions={['report']}><ProfitReport /></ProtectedRoute>} />
            <Route path="/money-report" element={<ProtectedRoute requiredPermissions={['report']}><MoneyMovementReport /></ProtectedRoute>} />
            <Route path="/activity-report" element={<ProtectedRoute requiredPermissions={['report']}><TotalActivityReport /></ProtectedRoute>} />
            <Route path="/remainings-report" element={<ProtectedRoute requiredPermissions={['report']}><RemainingsReport /></ProtectedRoute>} />

            {/* notification */}
            <Route path="/notifications" element={<ProtectedRoute requiredPermissions={['notification']}><Notifications /></ProtectedRoute>} />
            <Route path="/add-notification" element={<ProtectedRoute requiredPermissions={['notification']}><AddNotification /></ProtectedRoute>} />

            {/* whatsapp */}
            <Route path="/whatsapp-msgs" element={<ProtectedRoute requiredPermissions={['whatsAppMsg']}><WhatsAppMsgs /></ProtectedRoute>} />
            <Route path="/add-whatsapp-msg" element={<ProtectedRoute requiredPermissions={['whatsAppMsg']}><AddWhatsAppMsg /></ProtectedRoute>} />

            {/* user */}
            <Route path="/roles" element={<ProtectedRoute requiredPermissions={['role']}><Roles /></ProtectedRoute>} />
            <Route path="/users" element={<ProtectedRoute requiredPermissions={['user']}><Users /></ProtectedRoute>} />
            <Route path="/users/:id" element={<ProtectedRoute requiredPermissions={['user']}><UpdateUser /></ProtectedRoute>} />
            <Route path="/add-user" element={<ProtectedRoute requiredPermissions={['user']}><AddUser /></ProtectedRoute>} />

            {/* setting */}
            <Route path="/cities" element={<ProtectedRoute requiredPermissions={['city']}><Cities /></ProtectedRoute>} />
            <Route path="/city-prices" element={<ProtectedRoute requiredPermissions={['cityPrice']}><CityPrices /></ProtectedRoute>} />
            <Route path="/streets" element={<ProtectedRoute requiredPermissions={['street']}><Streets /></ProtectedRoute>} />
            <Route path="/branches" element={<ProtectedRoute requiredPermissions={['branch']}><Branches /></ProtectedRoute>} />
            <Route path="/post-types" element={<ProtectedRoute requiredPermissions={['postType']}><PostType /></ProtectedRoute>} />
            <Route path="/company-info" element={<ProtectedRoute requiredPermissions={['company']}><CompanyInfo /></ProtectedRoute>} />
            <Route path="/blocked-numbers" element={<ProtectedRoute requiredPermissions={['blockedNumber']}><BlockedNumbers /></ProtectedRoute>} />
            {/* <Route path="/printers" element={<ProtectedRoute requiredPermissions={['printer']}><Printers /></ProtectedRoute>} /> */}
            <Route path="/post-statuses" element={<ProtectedRoute requiredPermissions={['postStatus']}><PostStatuses /></ProtectedRoute>} />

            {/* profile */}
            <Route path="/profile" element={<Profile />} />
          </Route>
          <Route path="*" element={<Navigate to="/dashboard" />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;